
import {
  Vue, Component, Watch, Prop,
} from 'vue-property-decorator';
import Editor from '@/components/Editor.vue';
import { Lead, PermissionCode, User } from '@/types';
import UTILS from '@/lib/UTILS';
import API from '@/lib/API';
import { currentUserHasPermission, getLeadCustomValueDate, getLeadCustomValueText } from '@/helpers';

@Component({
  components: {
    Editor,
  },
})
export default class LeadOperationNotes extends Vue {
  @Prop({ type: Boolean, default: false }) readonly embedded!: boolean

  loading = false
  editing = false

  notes: string | null = null
  updatedAt: Date | null = null
  updatedBy: string | null = null

  async created() {
    console.log(`${this.constructor.name}: created()`); // eslint-disable-line no-console

    window.scrollTo(0, 0);

    this.notes = this.cvNotes;
    this.updatedAt = getLeadCustomValueDate(this.lead, 'opNotesUpdatedAt');
    this.updatedBy = await this.getUserNameFromCustomValue('opNotesUpdatedBy');
  }

  @Watch('cvNotes')
  async onCvNotes(val: string) {
    console.log(`${this.constructor.name}: onCvNotes()`); // eslint-disable-line no-console

    // Se le note sono state modificate altrove,
    // le aggiorna soltanto se non le si sta già modificando qua.
    // TODO: Non consentire la modifica se qualcun altro sta modificando (locking)
    if (!this.editing) {
      this.notes = val;
      this.updatedAt = getLeadCustomValueDate(this.lead, 'opNotesUpdatedAt');
      this.updatedBy = await this.getUserNameFromCustomValue('opNotesUpdatedBy');
    }
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get lead(): Lead | null {
    return this.$store.getters.currentLead;
  }

  get cvNotes(): string {
    return getLeadCustomValueText(this.lead, 'opNotes') ?? '';
  }

  hasPermission(codename: PermissionCode): boolean { return currentUserHasPermission(codename); }

  async getUserNameFromCustomValue(name: string): Promise<string | null> {
    const userId = this.lead ? UTILS.getCustomValueUserIdByName(this.lead, name) ?? null : null;
    const userName = userId ? await API.getUserName(userId) : null;
    return userName;
  }

  onEditing(editing: boolean) {
    console.log(`${this.constructor.name}: onEditing()`); // eslint-disable-line no-console

    this.editing = editing;
  }

  async onSave({ content, notify }: { content: string; notify: boolean }) {
    console.log(`${this.constructor.name}: onSave()`); // eslint-disable-line no-console

    this.loading = true;

    await this.$store.dispatch('updateLead', {
      updateType: 'opNotes',
      update: {
        notes: content,
        notify,
      },
    });

    setTimeout(() => {
      this.loading = false;
    }, 500);
  }

  onClose() {
    console.log(`${this.constructor.name}: onClose()`); // eslint-disable-line no-console

    this.$emit('close');
  }
}
